// src/components/PageLayout.js

// Shared page wrapper used by Home and Other.
// Renders a titled content card centered on the page.
function PageLayout({ title, children }) {
  return (
    <div className="min-h-screen bg-transparent flex flex-col items-center justify-start">
      <div className="relative mt-28 max-w-xl w-full text-center px-8 pt-10 pb-8">
        <span className="text-4xl font-bold absolute -top-6 left-7 font-mono text-orange-950">
          {title}
        </span>
        {children}
      </div>
    </div>
  );
}

export default PageLayout;